import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Channel } from '@yoimo/interfaces';
import { isEmpty } from 'lodash';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { map, mergeMap, scan } from 'rxjs/operators';
import { ChannelsService, ChannelType } from '../../shared/channels.service';

interface channelData {
  name: string;
  docId: string;
}
@Component({
  selector: 'app-new-channel-experience',
  templateUrl: './new-channel-experience.component.html',
  styleUrls: ['./new-channel-experience.component.scss'],
})
export class NewChannelExperienceComponent implements OnInit, OnDestroy {
  channelOffset = new BehaviorSubject<string | null>(null);
  clubSubs: Subscription = new Subscription();
  channelData!: Observable<(Channel & { id: string}) []>;
  showSpinner = false;
  filterChannelText = '';
  showClear = false;
  @ViewChild(CdkVirtualScrollViewport) viewport!: CdkVirtualScrollViewport;
  channels: channelData[] = [];
  ddOpen = false;
  ddName = '';
  dropdownListener: EventListener;
  masterChannel!: channelData;
  typeofChannel = '';
  channelType = ChannelType;
  channelSlug = '';
  endOfClub = false;
  constructor(
    private readonly dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { typeofChannel: boolean },
    private readonly channelsService: ChannelsService,
    private readonly dialogRef: MatDialogRef<NewChannelExperienceComponent>,
  ) {
    this.dropdownListener = (e: Event) => this.closeOrganizationDropdown(e);
    this.typeofChannel = this.channelType.ATTACH_CHANNEL;
  }

  ngOnInit(): void {
    this.getClub();
  }

  getClub() {
    const batchMap = this.channelOffset.pipe(
      mergeMap((n) => this.channelsService.getBatch('channels', n || '')),
      scan((acc, batch) => ({ ...acc, ...batch }), {}),
    );
    this.channelData = batchMap.pipe(map((v) => Object.values(v)));
    this.clubSubs = this.channelData.subscribe((result) => {
      this.channels = this.optionGrouping(result);
      this.showSpinner = false;
    });
  }
  applyChannelSearch() {
    if (this.filterChannelText == '') {return;}
    // this.searchFilterText=this.filterChannelText
    this.showClear = true;
    this.clubSubs.unsubscribe();
    this.showSpinner = true;
    this.channels = [];
    this.endOfClub = true;
    const channelSubs = this.channelsService
      .getClubByName('channels', this.filterChannelText)
      .subscribe((result) => {
        const filteredChannel = result.filter((item) =>
          item.name
            .toLowerCase()
            .includes(this.filterChannelText.toLowerCase()),
        );

        this.channels = this.optionGrouping(filteredChannel);
        this.showSpinner = false;
        channelSubs.unsubscribe();
      });
  }
  clearChannelSearch() {
    this.clubSubs.unsubscribe();
    this.filterChannelText = '';
    // this.searchFilterText = ''
    // this.showSpinner = true
    this.channels = [];
    this.endOfClub = false;
    this.channelOffset.next(null);
    this.nextBatch('');
    this.getClub();
    this.showClear = false;
  }
  nextBatch(offset: string) {
    if (this.endOfClub) {
      return;
    }
    this.channelOffset.next(offset);
    this.showSpinner = true;
  }
  optionGrouping(optionValues: (Channel & { id: string}) []) {
    return optionValues
      .filter((item) => !item.archived)
      .map((item) => ({
        name: item.name,
        docId: item.id,
      }));
  }
  dropDownDivOpen(dropName: string, fromBlur?: string) {
    if (dropName === 'Organization')
      {window.addEventListener('click', this.dropdownListener, false);}
    if (dropName === '')
      {window.removeEventListener('click', this.dropdownListener, false);}
    if (this.showClear) {this.clearChannelSearch();}
    if (fromBlur && !this.ddOpen) {return;}
    this.ddOpen = true;
    this.ddName = dropName;
    this.resetFilter();
  }
  resetFilter() {
    // this.filterDropText=''
    // this.filterCountryText = ""
    // this.filterSportText = ""
    // this.filterCurrencyText = ""
    // this.filterList=undefined
  }
  closeOrganizationDropdown(evt: Event) {
    const className: string = (evt.target as HTMLInputElement).className;
    if (className.includes('organization-select-div')) {return;}
    if (className.includes('org-search')) {return;}
    this.dropDownDivOpen('');
  }
  setOrganization(channel: channelData) {
    this.masterChannel = channel;
  }
  hideChannel(channel: channelData) {
    return (
      channel.name
        .toString()
        .toLowerCase()
        .indexOf(this.filterChannelText.toLowerCase()) == -1
    );
  }
  close() {
    this.dialogRef.close();
  }
  applyChanges() {
    const data =
      this.typeofChannel === this.channelType.ATTACH_CHANNEL
        ? {
            typeofChannel: this.typeofChannel,
            channelId: this.masterChannel?.docId || '',
            channelName: this.masterChannel?.name || '',
          }
        : {
            typeofChannel: this.typeofChannel,
            slug: this.channelSlug,
          };
    this.dialogRef.close(data);
  }
  ngOnDestroy() {
    if (this.clubSubs) {this.clubSubs.unsubscribe();}
    this.endOfClub = false;
  }
  disableApply() {
    if (this.typeofChannel === this.channelType.ATTACH_CHANNEL)
      {return this.masterChannel === undefined;}
    return isEmpty(this.channelSlug);
  }
  slugValidation(event: KeyboardEvent) {
    const currentSlug = this.channelSlug + event.key + 'slug';
    const regex = /^[a-zA-Z0-9]+((-{1})([a-z0-9A-Z])+){0,}$/;
    if (currentSlug.match(regex)) {
      return true;
    }
    return false;
  }

  slugValidationOnPaste(event: ClipboardEvent) {
    const copiedSlug = event.clipboardData?.getData('text') || '';
    const regex = /^[a-zA-Z0-9]+((-{1})([a-z0-9A-Z])+){0,}$/;
    if (copiedSlug.match(regex)) {
      return true;
    }
    return false;
  }
}
